import React from 'react'
import cx from 'classnames'

import "./CloseButton.scss"

const CloseButton = ({ onClickButton, outlineOnly = false }) => (
    <button className={cx({
        'site-close-button-outline': outlineOnly,
        'site-close-button': !outlineOnly
    })} onClick={onClickButton} />
)

export default CloseButton



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/CloseButton.jsx